// This is a public key by design. Create a Turnstile widget for the deployed
// hostname, then set its site key here before a public application campaign.
export const publicConfig = {
  turnstileSiteKey: '0x4AAAAAAEsvpKMUm8_R47d_',
  // Organizer-provided Google Form is the single public application destination.
  registrationUrl: 'https://forms.gle/KTWpwgdxfmriY7tPA',
  lineOfficialUrl: 'https://lin.ee/sUdQAGG',
  registrationQrImage: '',
  // Official channels supplied by the owner. Preserve the supplied share URLs.
  social: {
    facebookUrl: 'https://www.facebook.com/share/17jS8cHrFY/?mibextid=wwXIfr',
    instagramUrl: 'https://www.instagram.com/empressofwellness_?igsh=MTFmeW4ybmwxcWc3dQ%3D%3D&utm_source=qr',
    tiktokUrl: 'https://www.tiktok.com/@empress.of.wellne?_r=1&_t=ZS-97QIBQWKPqs',
    contactEmail: 'empressofwellness2026@gmail.com',
  },
}
